<template>
  <div>
    <main>
      <Alerts :success="isSuccess" :error="error" />
      <slot></slot>
      <ChatBot />

    </main>
  </div>
</template>

<script>
import { Alerts } from "@/components/t-components";
import { mapGetters } from "vuex";
import ChatBot from '@/components/t-components/ChatBot';

export default {
  name: "BaseLayout",
  components: {
    Alerts,
    ChatBot
  },
  computed: {
    ...mapGetters(["isSuccess", "error"]),
  },
  data() {
    return {};
  },
};
</script>